import { StaticQuery, graphql } from 'gatsby'
import React from 'react'
import Img from 'gatsby-image'
import marked, { inlineLexer } from 'marked'
import { injectIntl } from 'react-intl'
import { findLocalized } from '../utils'

const Accomodation = ({intl: {locale}}) => (
  <StaticQuery
    query={graphql`
      query {
        hotelStelline: file(relativePath: {eq: "contents/Hotel_Palazzo_Stelline_copertina_storia_0.jpg"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        }   
        anticalocanda: file(relativePath: {eq: "contents/anticalocanda.jpg"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        } 
        ambrogio: file(relativePath: {eq: "contents/BB_Santambrogio.jpg"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        } 
        allAccomodationYaml{
          edges{
            node{
              title
              info
              accomodations{
                title
                subtitle
                infos
              }
              lang
            }
          }
        }   
      }
    `}
    render={data => {
      const { title, info, accomodations } = findLocalized(data.allAccomodationYaml, locale);
      const [hotel, locanda, bb] = accomodations;
      return (
        <section id="accomodation" className="section accomodation" aria-labelledby="region3">
          <div className="container">
            <div className="row" data-aos="fade-up">
              <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                <h1 id="region3" className="section__title text-center">{title}</h1>
                <div className="row">
                  <div className="col-sm-12" dangerouslySetInnerHTML={{__html: marked(info)}}></div>
                </div>
                <div className="accomodation__text">
                  <div className="row">
                    <div className="col-sm-4 col-md-5">
                      <Img fluid={data.hotelStelline.childImageSharp.fluid} alt={hotel.title} className="" />
                    </div>
                    <div className="col-sm-8 col-md-7">
                      <h2 className="accomodation__title">{hotel.title}</h2>
                      <p>{hotel.subtitle}</p>
                      {hotel.infos.map((item, i) => <div key={i} dangerouslySetInnerHTML={{__html: inlineLexer(item, [])}}></div>)}
                      <br />
                      <div className="accomodation__site"><a target="_blank" rel="noopener noreferrer" title={hotel.title} href="https://www.hotelpalazzostelline.it/">www.hotelpalazzostelline.it</a></div>
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-sm-4 col-md-5">
                      <Img fluid={data.anticalocanda.childImageSharp.fluid} alt={locanda.title} className="" />
                    </div>
                    <div className="col-sm-8 col-md-7">
                      <h2 className="accomodation__title">{locanda.title}</h2>
                      <p>{locanda.subtitle}</p>
                      {locanda.infos.map((item, i) => <div key={i} dangerouslySetInnerHTML={{__html: inlineLexer(item, [])}}></div>)}
                      <br />
                      <div className="accomodation__site"><a target="_blank" rel="noopener noreferrer" title={locanda.title} href="https://www.anticalocandaleonardo.com/">www.anticalocandaleonardo.com</a></div>
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-sm-4 col-md-5">
                      <Img fluid={data.ambrogio.childImageSharp.fluid} alt={bb.title} className="" />
                    </div>
                    <div className="col-sm-8 col-md-7">
                      <h2 className="accomodation__title">{bb.title}</h2>
                      <p>{bb.subtitle}</p>
                      {bb.infos.map((item, i) => <div key={i} dangerouslySetInnerHTML={{__html: inlineLexer(item, [])}}></div>)}
                      <br />
                      <div className="accomodation__site"><a target="_blank" rel="noopener noreferrer" title={bb.title} href="https://www.hotel-bb.com/it/hotel/milano-sant-ambrogio.htm?utm_source=googlemaps&utm_medium=fichehotel&utm_content=it&utm_campaign=milano">www.hotel-bb.com</a></div>
                    </div>
                  </div>
                </div>
                {/*
              <div className="row">
                <div className="col-sm-12">
                  <br /><br />
                  <h2 className="section__subject text-center">Dove mangiare</h2>
                  <p>
                    In esclusiva per i partecipanti all'evento, nei giorni 3 e 4 ottobre, il <a href="https://www.10gradinord.com/" title="10gradinord" target="_blank" rel="noopener noreferrer">10gradinord</a> offre:<br />
                    <strong>aperitivo con tagliere gratuito e 2^ birra in omaggio</strong> dalle ore 17,00.
                  </p>
                </div>
              </div>
              */}
              </div>
            </div>
          </div>
        </section>
      )
    }}
  />
);

export default injectIntl(Accomodation);
